import queryString from "query-string";

import { WEIGH_LOT_SCAN } from "constants/actionTypes";

import { serializeWeighLotScan } from "lib/serializers/weighLotScans";

import { offlineActionCreator, urlCheckAndAddIdAndAction } from "./lib";

const urlCreator = ({ changesSince, livestockSaleId, id, action } = {}) =>
  queryString.stringifyUrl({
    url: urlCheckAndAddIdAndAction("/v2/weigh-lot-scans/", id, action),
    query: {
      weigh_lot__livestock_sale_id: livestockSaleId,
      changesSince,
    },
  });

export const WeighLotScanAction = offlineActionCreator(
  WEIGH_LOT_SCAN,
  serializeWeighLotScan,
  urlCreator,
  true,
);

/**
 * Keeps a batch of Weigh Lot Scans in a single request - the backend decides reweigh vs mapped
 * status, ignores any siblings sharing the same EID, and relinks + recalculates the associated
 * Scan's weight for each one. The reducer optimistically predicts and rolls back the same
 * decision client-side (see `reducers/weighLotScans.js`), so this just needs the ids.
 *
 * @param {Array<String>} weighLotScanIds
 */
WeighLotScanAction.keep = weighLotScanIds => ({
  type: WEIGH_LOT_SCAN.KEEP.REQUEST,
  payload: weighLotScanIds,
  meta: {
    offline: {
      effect: {
        url: "/v2/weigh-lot-scans/keep/",
        method: "POST",
        body: JSON.stringify({ weigh_lot_scan_ids: weighLotScanIds }),
      },
      commit: {
        type: WEIGH_LOT_SCAN.KEEP.SUCCESS,
        meta: { weighLotScanIds },
      },
      rollback: {
        type: WEIGH_LOT_SCAN.KEEP.FAILURE,
        meta: { weighLotScanIds },
      },
    },
  },
});

/**
 * Ignores a batch of Weigh Lot Scans in a single request - the backend marks each as ignored and
 * unlinks + recalculates the weight of any associated Scan.
 *
 * @param {Array<String>} weighLotScanIds
 */
WeighLotScanAction.ignore = weighLotScanIds => ({
  type: WEIGH_LOT_SCAN.IGNORE.REQUEST,
  payload: weighLotScanIds,
  meta: {
    offline: {
      effect: {
        url: "/v2/weigh-lot-scans/ignore/",
        method: "POST",
        body: JSON.stringify({ weigh_lot_scan_ids: weighLotScanIds }),
      },
      commit: {
        type: WEIGH_LOT_SCAN.IGNORE.SUCCESS,
        meta: { weighLotScanIds },
      },
      rollback: {
        type: WEIGH_LOT_SCAN.IGNORE.FAILURE,
        meta: { weighLotScanIds },
      },
    },
  },
});

WeighLotScanAction.addScanToSale = weighLotScanId => {
  return {
    type: WEIGH_LOT_SCAN.ADD_SCAN_TO_SALE.ACTION,
    weighLotScanId,
  };
};

WeighLotScanAction.manaullyMapToScan = (weighLotScanId, scan) => {
  return {
    type: WEIGH_LOT_SCAN.MANUALLY_MAP_TO_SCAN.ACTION,
    weighLotScanId,
    scan,
  };
};

WeighLotScanAction.addWeightToSaleLot = (weighLotScanId, saleLotId) => {
  return {
    type: WEIGH_LOT_SCAN.ADD_WEIGH_TO_SALE_LOT.ACTION,
    weighLotScanId,
    saleLotId,
  };
};
